/* eslint-disable no-unused-vars */
import React, { useState } from "react"
import * as Yup from "yup"
import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@material-ui/core"
import { Formik } from "formik"
import BlockIcon from "@material-ui/icons/Block"
import { useSnackbar } from "notistack"
import { Add } from "@material-ui/icons"
import { sendEncuesta, updateEncuesta } from "src/services/admin/vote"
import { StyledButton } from "src/components/Buttons/TgButton"
import useStyles from "../../metodosDePago/activos/useStyles"

const NewSurvey = ({ encuestas, conjunto, tGlobal, tSurvey }) => {
  const classes = useStyles()
  const { enqueueSnackbar } = useSnackbar()
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const encuestaActiva = encuestas.find(encuesta => encuesta.isActive === true)

  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setLoading(false)
    setOpen(false)
  }

  return (
    <>
      <StyledButton
        variant="outlined"
        color="primary"
        style={{ marginTop: 10 }}
        onClick={handleOpen}
      >
        <Add className="me-2" />
        {tSurvey("new_survey")}
      </StyledButton>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="draggable-dialog-title"
        fullWidth
      >
        <Formik
          initialValues={{
            Encuesta: "",
            Loop: 30,
          }}
          validationSchema={Yup.object().shape({
            Encuesta: Yup.string().required().max(100),
            Loop: Yup.number().min(1).max(30).integer().typeError(),
          })}
          onSubmit={async values => {
            setLoading(true)
            const existEncuesta = encuestas.some(
              encuesta => encuesta.title === values.Encuesta
            )
            try {
              if (!existEncuesta) {
                const valueData = {}
                valueData.title = values.Encuesta
                valueData.loop = values.Loop || 30
                valueData.isActive = true
                if (encuestaActiva) {
                  await updateEncuesta(conjunto.id, encuestaActiva.id, {
                    isActive: false,
                  })
                }
                await sendEncuesta(conjunto.id, valueData).then(() => {
                  setLoading(false)
                  enqueueSnackbar(tSurvey("success_created_survey"), {
                    variant: "success",
                  })
                  handleClose()
                })
              } else {
                enqueueSnackbar(tSurvey("error_exists_survey"), {
                  variant: "error",
                })
                setLoading(false)
              }
            } catch (error) {
              enqueueSnackbar(tSurvey("error_create_survey"), {
                variant: "error",
              })
              setLoading(false)
              handleClose()
            }
          }}
        >
          {({
            values,
            handleChange,
            handleBlur,
            errors,
            touched,
            isSubmitting,
            handleSubmit,
          }) => (
            <form onSubmit={handleSubmit}>
              <DialogTitle
                style={{ cursor: "move" }}
                id="draggable-dialog-title"
              >
                <b>{tSurvey("create_survey")}</b>
              </DialogTitle>
              {loading ? (
                <Box display="flex" justifyContent="center" my={5}>
                  <CircularProgress />
                </Box>
              ) : (
                <DialogContent>
                  {encuestaActiva && (
                    <DialogContentText
                      className={classes.textAlert}
                      style={{ color: "#cc493f" }}
                    >
                      <b>{tSurvey("exist_survey_info")}</b>
                      <br />
                    </DialogContentText>
                  )}
                  <DialogContentText>{`${tSurvey(
                    "new_survey"
                  )}:`}</DialogContentText>
                  <TextField
                    name="Encuesta"
                    label={tGlobal("survey")}
                    id="pregunta"
                    variant="outlined"
                    fullWidth
                    minRows={2}
                    value={values.Encuesta}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.Encuesta && Boolean(errors.Encuesta)}
                    helperText={touched.Encuesta && errors.Encuesta}
                  />
                  <DialogContentText>
                    {tSurvey("show_survey")}
                  </DialogContentText>
                  <TextField
                    name="Loop"
                    label={tSurvey("default_days")}
                    type="number"
                    variant="outlined"
                    size="small"
                    fullWidth
                    inputProps={{
                      min: 1,
                      max: 30,
                      step: 1,
                    }}
                    onChange={handleChange}
                    value={values.Loop}
                    onBlur={handleBlur}
                    error={touched.Loop && Boolean(errors.Loop)}
                    helperText={touched.Loop && errors.Loop}
                  />
                </DialogContent>
              )}
              <DialogActions>
                <StyledButton
                  autoFocus
                  onClick={handleClose}
                  variant="contained"
                  color="primary"
                  startIcon={
                    <BlockIcon fontSize="small" className={classes.iconRed} />
                  }
                >
                  {tGlobal("cancel")}
                </StyledButton>
                <StyledButton
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting}
                >
                  {tGlobal("confirm")}
                </StyledButton>
              </DialogActions>
            </form>
          )}
        </Formik>
      </Dialog>
    </>
  )
}

export default NewSurvey
